var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discipline-explanatory-cell" },
    [
      _vm.record.explanatory.value === "available" &&
      _vm.record.isFined.toString() === "0" &&
      _vm.record.explanatoryWriteAccess
        ? _c("c-button", {
            staticClass: "m-auto discipline-explanatory-cell-need-write",
            attrs: { size: "small", label: "Написать" },
            on: {
              click: function ($event) {
                _vm.isShowWriteExplanatoryModal = true
              },
            },
          })
        : _vm._e(),
      _vm.record.explanatory.value === "expired"
        ? [_vm._v("Просрочено")]
        : _vm._e(),
      _vm.record.isFined.toString() === "1"
        ? [_vm._v("Выписан штраф")]
        : _vm._e(),
      _vm.record.explanatory.value === "explanatory"
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Просмотр объяснительной",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Просмотр объяснительной',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            key: "explanatory",
            attrs: { size: "iconic", icon: "explanatory" },
            on: {
              click: function ($event) {
                _vm.isShowExplanatoryModal = true
              },
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "m-show-explanatory" },
        [
          _c(
            "b-modal",
            {
              attrs: {
                id: "discipline-show-explanatory-modal",
                size: "custom-size",
                "no-enforce-focus": "",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
              },
              on: {
                show: _vm.onShowExplanatoryModal,
                close: function ($event) {
                  _vm.isShowExplanatoryModal = false
                },
              },
              model: {
                value: _vm.isShowExplanatoryModal,
                callback: function ($$v) {
                  _vm.isShowExplanatoryModal = $$v
                },
                expression: "isShowExplanatoryModal",
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "m-show-explanatory-close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowExplanatoryModal = false
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "m-show-explanatory-title" }, [
                _vm._v("Просмотр объяснительной"),
              ]),
              _vm.isShowExplanatoryModalLoaded
                ? _c(
                    "div",
                    { staticClass: "m-show-explanatory-loader" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.icon, spin: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isShowExplanatoryModalLoaded
                ? _c("div", { staticClass: "m-show-explanatory-fullname" }, [
                    _vm._v(
                      " " + _vm._s(_vm.workerNameShowExplanatoryModal) + ", "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.dateShowExplanatoryModal))]),
                  ])
                : _vm._e(),
              !_vm.isShowExplanatoryModalLoaded
                ? _c(
                    "div",
                    { staticClass: "m-show-explanatory-request-header" },
                    [_vm._v(" " + _vm._s(_vm.record.reason.value) + " ")]
                  )
                : _vm._e(),
              !_vm.isShowExplanatoryModalLoaded
                ? _c("div", { staticClass: "position-relative" }, [
                    _c("div", {
                      staticClass: "m-show-explanatory-content-shadow-top",
                      attrs: { id: "m-show-explanatory-content-shadow-top" },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "m-show-explanatory-content",
                        attrs: { id: "m-show-explanatory-content" },
                        on: { scroll: _vm.setShadowsShowExplanatoryModalItems },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "m-show-explanatory-content-mr" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-show-explanatory-fullname m-show-explanatory-fullname-mobile",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.workerNameShowExplanatoryModal) +
                                    ", "
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.dateShowExplanatoryModal)),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-show-explanatory-request-header m-show-explanatory-request-header-mobile",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.record.reason.value) + " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "m-show-explanatory-content-text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.textShowExplanatoryModal
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.textShowExplanatoryModal) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "viewer",
                              {
                                staticClass:
                                  "m-show-explanatory-content-images",
                                attrs: {
                                  photos: _vm.imagesExplanatoryModal.map(
                                    (img) => img.src
                                  ),
                                },
                              },
                              _vm._l(
                                _vm.imagesExplanatoryModal,
                                function (item) {
                                  return _c("img", {
                                    key: item.src,
                                    staticClass:
                                      "m-show-explanatory-content-images-img",
                                    attrs: { src: item.src },
                                    on: {
                                      click:
                                        _vm.onClickImageExplanatoryShowModal,
                                    },
                                  })
                                }
                              ),
                              0
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", {
                      staticClass: "m-show-explanatory-content-shadow-bottom",
                      attrs: { id: "m-show-explanatory-content-shadow-bottom" },
                    }),
                  ])
                : _vm._e(),
              _c("c-button", {
                staticClass: "m-show-explanatory-button-close",
                attrs: { label: "Закрыть" },
                on: {
                  click: function ($event) {
                    _vm.isShowExplanatoryModal = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "m-write-explanatory" },
        [
          _c(
            "b-modal",
            {
              attrs: {
                id: "discipline-write-explanatory-modal",
                size: "custom-size",
                "no-enforce-focus": "",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
              },
              on: {
                close: function ($event) {
                  _vm.isShowWriteExplanatoryModal = false
                },
              },
              model: {
                value: _vm.isShowWriteExplanatoryModal,
                callback: function ($$v) {
                  _vm.isShowWriteExplanatoryModal = $$v
                },
                expression: "isShowWriteExplanatoryModal",
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "m-write-explanatory-close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowWriteExplanatoryModal = false
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "m-write-explanatory-title" }, [
                _vm._v("Отправить объяснительную"),
              ]),
              _c("div", { staticClass: "position-relative" }, [
                _c("div", {
                  staticClass: "m-write-explanatory-content-shadow-top",
                  attrs: { id: "m-write-explanatory-content-shadow-top" },
                }),
                _c(
                  "div",
                  {
                    staticClass: "m-write-explanatory-content",
                    attrs: { id: "m-write-explanatory-content" },
                    on: { scroll: _vm.setShadowsWriteExplanatoryModalItems },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "m-write-explanatory-editor",
                        attrs: { id: "m-write-explanatory-editor" },
                        on: {
                          focusin: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("editor", {
                          attrs: {
                            "api-key": _vm.tinymceApiKey,
                            init: _vm.tinymceConfig,
                          },
                          model: {
                            value: _vm.explanatoryTextLocal,
                            callback: function ($$v) {
                              _vm.explanatoryTextLocal = $$v
                            },
                            expression: "explanatoryTextLocal",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.modalWriteExplanatoryAppendImages.length > 0
                      ? _c(
                          "viewer",
                          {
                            ref: "writeExplanatoryModalViewer",
                            staticClass: "m-write-explanatory-photos",
                            attrs: {
                              images: _vm.modalWriteExplanatoryAppendImages.map(
                                (img) => img.url
                              ),
                            },
                          },
                          _vm._l(
                            _vm.modalWriteExplanatoryAppendImages,
                            function (img, index) {
                              return _c(
                                "div",
                                {
                                  key: `${index}-img`,
                                  staticClass:
                                    "m-write-explanatory-photos-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column justify-content-center",
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "m-write-explanatory-photos-item-photo",
                                        attrs: { src: img.url },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "m-write-explanatory-photos-item-name",
                                        },
                                        [_vm._v(_vm._s(img.name))]
                                      ),
                                    ]
                                  ),
                                  _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "hover blur",
                                          content: "Удалить",
                                          placement: "top",
                                        },
                                        expression:
                                          "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Удалить',\n                  placement: 'top',\n                }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    staticClass:
                                      "m-write-explanatory-photos-item-trash",
                                    attrs: { size: "iconic", icon: "trash" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeImage(index, img.name)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", {
                  staticClass: "m-write-explanatory-content-shadow-bottom",
                  attrs: { id: "m-write-explanatory-content-shadow-bottom" },
                }),
              ]),
              _c("c-button", {
                staticClass: "m-write-explanatory-add-photo",
                class: {
                  "m-write-explanatory-add-photo-photos-empty":
                    _vm.modalWriteExplanatoryAppendImages.length === 0,
                },
                attrs: {
                  disabled: _vm.modalWriteExplanatoryAppendImages.length === 20,
                  size: "small",
                  icon: { icon: "plus", color: "primary" },
                  label: "Добавить фото",
                },
                on: {
                  click: function ($event) {
                    return _vm.chooseFiles()
                  },
                },
              }),
              _c("div", { staticClass: "m-write-explanatory-error-message" }, [
                _vm.isModalWriteExplanatorySubmitError ||
                _vm.isModalWriteExplanatoryFileLarge
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "7",
                            cy: "7",
                            r: "6.5",
                            fill: "white",
                            stroke: "#FF238D",
                          },
                        }),
                        _c("circle", {
                          attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "6",
                            y: "3",
                            width: "2",
                            height: "5",
                            rx: "1",
                            fill: "#FF238D",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "m-write-explanatory-error-message-text" },
                  [_vm._v(" " + _vm._s(_vm.errorText) + " ")]
                ),
              ]),
              _c("input", {
                ref: "writeExplanatoryFileUpload",
                attrs: {
                  id: "m-write-file-upload",
                  name: "attachment[]",
                  multiple: "",
                  type: "file",
                  accept: "image/gif, image/jpeg, image/png, image/jpg",
                  hidden: "",
                },
                on: { change: _vm.onFileChange },
              }),
              _c(
                "div",
                { staticClass: "m-write-explanatory-buttons" },
                [
                  _c("c-button", {
                    staticClass: "m-write-explanatory-buttons-cancel",
                    attrs: { label: "Отменить" },
                    on: {
                      click: function ($event) {
                        _vm.isShowWriteExplanatoryModal = false
                      },
                    },
                  }),
                  _c("c-button", {
                    staticClass: "m-write-explanatory-buttons-submit",
                    attrs: { color: "primary", label: "Сохранить" },
                    on: { click: _vm.submitExplanatory },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }